import React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import useLanguage from '../../../../hooks/useLanguage';
// import PropTypes from 'prop-types';

const Terms = () => {
  const langToggle = useLanguage;
  return (
    <div className="form-terms_wrapper form-animate">
      <p className="form-terms">
        <span className="form-terms__text">
          {langToggle(
            'Натискаючи на кнопку, ви даєте згоду на обробку ',
            'Нажимая на кнопку, вы даете согласие на обработку'
          )}
        </span>
        <Link to="/privacy-policy/" className="form-terms__link">
          {langToggle('персональних даних', 'персональных данных')}
        </Link>
      </p>
    </div>
  );
};

// Terms.propTypes = {};

export default Terms;
